<app-embedded-mobile-header></app-embedded-mobile-header>
<mat-card class="wrapper mat-elevation-z">
    <mat-card-title>
        <h2 i18n>Page Expired</h2>
    </mat-card-title>
    <mat-card-content>
        <p i18n class="lead">
            The connection to this page was interrupted or the session expired. Please reload the page. If the problem persists, please sign
            out and sign in again.
        </p>
        <div class="btnWrapper">
            <button i18n mat-raised-button (click)="reload()">Reload</button>
        </div>
    </mat-card-content>
</mat-card>
